import { HeaderSection } from 'components/common/HeaderSection';
import { FC, useEffect, useState } from 'react';
import { Footer } from 'components/common/Footer';
import { ContactSection } from 'components/common/ContactSection';
import { MainSection } from 'components/Methodology/MainSection';
import { Header } from 'components/common/Header';
import { StyledFixedHeaderContainer } from './Methodology.styled';
import { SEO } from 'components/common/SEO';
import { content, description, imageUrl, title } from './config';
import { useWindowSize } from 'hooks/useWindowSize';

export const Methodology: FC = () => {
  const { isMobile } = useWindowSize();
  const [showFixedHeader, setShowFixedHeader] = useState(false);
  const [prevScrollPos, setPrevScrollPos] = useState(0);

  const handleScroll = () => {
    const offset = window.scrollY;

    if (isMobile) {
      if (offset < prevScrollPos && offset > 70) {
        setShowFixedHeader(true);
      } else {
        setShowFixedHeader(false);
      }
    } else {
      const section = document.querySelector('.main-section');
      if (section) {
        const sectionTop = section.getBoundingClientRect().top + window.scrollY;
        if (offset >= sectionTop) {
          setShowFixedHeader(true);
        } else {
          setShowFixedHeader(false);
        }
      }
    }
    setPrevScrollPos(offset);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isMobile, prevScrollPos]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEO
        title={title}
        description={description}
        imageUrl={imageUrl}
        content={content}
      />
      <HeaderSection
        label="Methodik"
        description="Umfassende, datengestützte Auswertung für fundierte Investitionsentscheidungen"
      />
      {showFixedHeader && (
        <StyledFixedHeaderContainer showFixedHeader={showFixedHeader}>
          <Header expandableMenuVariant="secondary" />
        </StyledFixedHeaderContainer>
      )}
      <MainSection />
      <ContactSection />
      <Footer />
    </>
  );
};
